import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoRo: CultureInfo = {
  name: 'ro',
  displayName: 'Romanian',
  iso3LanguageCode: 'ron',
  iso2LanguageCode: 'ro',
  ietfLanguageTag: 'ro',
  parent: null
};
